import React, { useEffect, useRef, useState } from 'react';
import './review-list-styles.css';
import { Modal } from '../Utils/Modal/modal-component';

const ShortsList = ({ shorts }) => {
    const scrollContainerRef = useRef(null);
    const [isHovering, setIsHovering] = useState(false);
    const [videoLoaded, setVideoLoaded] = useState(Array(shorts.length).fill(false)); // Track loading state for each video
    const [scrollDirection, setScrollDirection] = useState(1); // 1 for right, -1 for left
    const [selectedVideo, setSelectedVideo] = useState(null); // Holds the currently selected video
    const [modalOpen, setModalOpen] = useState(false); // Controls modal visibility

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container) return;

        // Smooth continuous scroll function
        const smoothScroll = () => {
            if (!isHovering) {
                container.scrollLeft += scrollDirection; // Increment or decrement based on direction

                // Reverse direction at ends
                if (
                    container.scrollLeft >= container.scrollWidth - container.clientWidth ||
                    container.scrollLeft <= 0
                ) {
                    setScrollDirection(-scrollDirection);
                }
            }
        };

        // Set up interval for continuous scrolling
        const interval = setInterval(smoothScroll, 20); // Adjust time for speed

        // Event listeners for hover state
        const handleMouseEnter = () => setIsHovering(true);
        const handleMouseLeave = () => setIsHovering(false);
        container.addEventListener('mouseenter', handleMouseEnter);
        container.addEventListener('mouseleave', handleMouseLeave);

        // Clean-up function
        return () => {
            clearInterval(interval);
            container.removeEventListener('mouseenter', handleMouseEnter);
            container.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [isHovering, scrollDirection]);

    const handleVideoLoad = (index) => {
        setVideoLoaded((prev) => {
            const updatedStatus = [...prev];
            updatedStatus[index] = true; // Mark the video as loaded
            return updatedStatus;
        });
    };

    const handleVideoClick = (short) => {
        setSelectedVideo(short); // Set the clicked video as selected
        setModalOpen(true); // Open the modal
    };

    const handleModalClose = () => {
        setModalOpen(false); // Close the modal
        setSelectedVideo(null); // Reset the selected video
    };

    const handleWatchVideo = () => {
        if (selectedVideo) {
            window.open(selectedVideo.link, '_blank', 'noopener,noreferrer');
        }
        handleModalClose();
    };

    return (
        <div ref={scrollContainerRef} className="flex overflow-auto w-screen">
            {shorts.map((short, index) => (
                <div key={index} className="review-card-wrapper">
                    <div
                        className="relative bg-white dark:bg-black w-[200px] h-auto lg:w-[300px] rounded-xl shadow-md hover:shadow-2xl transition-all ease-in-out duration-400"
                        onClick={() => handleVideoClick(short)}
                    >
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className={`rounded-2xl ${videoLoaded[index] ? 'opacity-100' : 'opacity-0'
                                } transition-opacity duration-150`}
                            onLoadedData={() => handleVideoLoad(index)} // Triggered when video is ready
                            onError={() => console.error(`Failed to load video at index ${index}`)}
                        >
                            <source src={short.video} type="video/mp4" />
                        </video>

                        {/* View Counter */}
                        <div className="absolute bottom-2 left-3 bg-opacity-70 text-white text-center rounded-lg z-10">
                            <h1>{short.views} views</h1>
                        </div>
                    </div>
                </div>
            ))}

            {/* Modal */}
                <Modal expand={modalOpen} timeout={false}>
                    <div className="flex w-full h-full bg-white dark:bg-black flex-col justify-center items-center">
                        <h1 className="mb-4 text-2xl font-extrabold tracking-tight leading-none text-gray-900 md:text-4xl lg:text-5xl dark:text-white">
                            Do you want to watch this video?
                        </h1>
                        <div className="flex space-x-4">
                            <button
                                className="inline-flex justify-center items-center py-3 px-5 text-base font-bold text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:bg-blue-500 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                onClick={handleWatchVideo}
                            >
                                Watch Video
                            </button>
                            <button
                                className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:bg-black dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
                                onClick={handleModalClose}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </Modal>
        </div>
    );
};

export default ShortsList;